module.exports = __webpack_public_path__ + "static/media/entree-bed.0b064b22.svg";